import documentInit from './modules/document';
import mobileNavInit from './modules/mobile-nav';
import formInit from './modules/form';
import codeVerifierInit from './modules/code-verifier';


(function ($) {

	$(document).ready(function () {

		documentInit();
		mobileNavInit();
		formInit();
		codeVerifierInit();

	});

})(jQuery);